@if (isInitialized) {
<oe-flat-widget button [title]="component.alias" [icon]="{name:
    'cloud-outline', color: 'normal'}" [modalComponent]="modalComponent">
    <oe-flat-widget-line [name]="'GENERAL.MODE' | translate" [channelAddress]="component.id + '/_PropertyMode'"
    [converter]="CONVERT_MODE_TO_MANUAL_OFF_AUTOMATIC"></oe-flat-widget-line>
    <oe-flat-widget-line leftColumnWidth="20" [name]="'GENERAL.STATUS' | translate"
      [converter]="CONVERT_TIME_OF_USE_TARIFF_STATE" [channelAddress]="component.id + '/StateMachine'">
    </oe-flat-widget-line>
  </oe-flat-widget>
}
